import React from 'react';
import { Link } from 'react-router-dom';
import { Box, Card, CardActionArea, Grid2, Typography, Paper, alpha, Stack } from '@mui/material';
import {
  Beenhere,
  Lock,
  ManageAccounts,
  Subject,
  TravelExplore,
  SettingsSuggestOutlined,
  ShieldOutlined,
  SettingsApplications,
} from '@mui/icons-material';
import { userCats } from '../../../helpers/appstate';
import UserSettingScreen from './UserSettingScreen';
import ConsultantSettings from './ConsultantSettings';

const SettingsContent = ({ props }) => {
  const { userCategory, userPermission } = props;
  const userCat = userCategory?.trim()?.toLowerCase();

  const userPerm = userPermission?.map((mp) => mp.trim().toLowerCase()) || [];

  // Logic Preserved
  const canViewLookup = userPerm.includes('manage_system_configurations');
  const canViewTemplate = userCat === 'edm';
  const canViewRoles = userPerm.includes('manage_system_configurations');
  const isEDM = userCategory === userCats.EDM;
  const isConsultant = userCat === 'consultant';

  const NavCard = ({ to, icon, label, color }) => (
    <Grid2 size={{ lg: 4, md: 6, sm: 6, xs: 12 }}>
      <Link to={to} style={{ textDecoration: 'none' }}>
        <Card
          elevation={0}
          sx={{
            width: '100%',
            aspectRatio: '1/1',
            borderRadius: '20px',
            border: '1px solid',
            borderColor: alpha(color, 0.2),
            transition: '0.3s',
            '&:hover': {
              transform: 'translateY(-5px)',
              boxShadow: `0 12px 30px ${alpha(color, 0.15)}`,
              borderColor: color,
            },
          }}
        >
          <CardActionArea
            sx={{
              height: '100%',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              bgcolor: alpha(color, 0.04),
              color: color,
              textAlign: 'center',
              p: 2,
            }}
          >
            <Box
              sx={{
                p: 2,
                borderRadius: '50%',
                bgcolor: alpha(color, 0.1),
                display: 'flex',
                mb: 2,
              }}
            >
              {icon}
            </Box>
            <Typography variant="body2" fontWeight={700} sx={{ color: 'text.primary', px: 1 }}>
              {label}
            </Typography>
          </CardActionArea>
        </Card>
      </Link>
    </Grid2>
  );

  // Every non-EDM category lands straight on their account page
  if (userCategory !== userCats.EDM) {
    return <UserSettingScreen props={props} />;
  }

  return (
    <Box sx={{ bgcolor: '#F4F6F8', minHeight: '100vh', p: { xs: 2, md: 4 } }}>
      {userCategory === userCats.EDM && (
        <Grid2 container spacing={6}>
          {/* SYSTEM SETTINGS SECTION */}
          <Grid2 size={{ lg: 6, md: 12, sm: 12, xs: 12 }}>
            <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 3 }}>
              <SettingsSuggestOutlined color="primary" />
              <Typography variant="h6" fontWeight={700} color="text.primary">
                System Configurations
              </Typography>
            </Stack>

            <Grid2 container spacing={3}>
              {canViewLookup && (
                <NavCard
                  to="/settings/lookups"
                  icon={<TravelExplore fontSize="large" />}
                  label="Lookup Management"
                  color="#2e7d32" // Success
                />
              )}

              {canViewTemplate && (
                <NavCard
                  to="/settings/templates"
                  icon={<Subject fontSize="large" />}
                  label="Template Management"
                  color="#0288d1" // Info
                />
              )}

              <NavCard
                to="/settings/configurations"
                icon={<SettingsApplications fontSize="large" />}
                label="Configuration Settings"
                color="#ed6c02" // Warning
              />
            </Grid2>
          </Grid2>

          {/* ACCOUNT SETTINGS SECTION */}
          <Grid2 size={{ lg: 6, md: 12, sm: 12, xs: 12 }}>
            <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 3 }}>
              <ShieldOutlined color="primary" />
              <Typography variant="h6" fontWeight={700} color="text.primary">
                Access & Identity
              </Typography>
            </Stack>

            <Grid2 container spacing={3}>
              <NavCard
                to="/settings/profile"
                icon={<ManageAccounts fontSize="large" />}
                label="My Personal Account"
                color="#9c27b0" // Purple/Secondary
              />

              {canViewRoles && (
                <NavCard
                  to="/settings/roles"
                  icon={<Beenhere fontSize="large" />}
                  label="Roles & Permissions"
                  color="#d32f2f" // Error
                />
              )}
            </Grid2>
          </Grid2>
        </Grid2>
      )}

      {/* {userCategory === userCats.CONSULTANT && <ConsultantSettings />} */}
    </Box>
  );
};

export default SettingsContent;
